import React, {useEffect, useState} from 'react'
import ChatPreview from "./modals/chat_preview";
import GroupChatPreview from "./modals/group_chat_preview";
import TextPreview from "./modals/text_preview";
import DownloadsPreview from "./modals/downloads_preview";
import RawHtmlPreview from "./modals/raw_html_preview";
import SupportChat from "./modals/support_chat";
import LeadGenerationPreview from "./modals/lead_generation_preview";
import PdfViewer from "./modals/pdf_viewer";
import ContactsPreview from "./modals/contacts_preview";
import MeetingPopup from "./modals/meeting_popup";
import DirectMessagingPopup from "./modals/direct_messaging_popup";
import IframePopup from "./modals/iframe_popup";
import InlineHtmlPreview from './modals/inline_html_preview'
import ChatRoulette from "./chat_roulette/chat_roulette";
import ChatRoulettePopup from "./modals/chat_roulette_popup";
import removePreselectedHotspotFromUrl from "../exhibition/utils";
import {useSelector} from "react-redux";

const MODAL_HOTSPOT_TYPES = [
  "chat",
  "group_chat",
  "text",
  "downloads",
  "iframe",
  "support_chat",
  "lead_generation",
  "pdf_viewer",
  "contact",
  "appointment",
  "direct_messaging",
  "iframe_url",
  "chat_roulette",
]

export function HotspotPreview({id, hotspot, kind, data, downloadFiles, imageMap, onModalClose}) {
  const imageHotspotConfigs = useSelector((state) => state.imageHotspotConfigs)
  const hotspotConfig = imageHotspotConfigs.find(hotspotConfig => hotspotConfig.id === hotspot?.image_hotspot_config_id)
  const [shouldBackOnModalClose, setShouldBackOnModalClose] = useState(false)

  let wrappedOnModalClose = () => {
    window.isHotspotModalOpenImageMapId_UNIQUE_GLOBAL = null
    window.onpopstate = null
    if (shouldBackOnModalClose) {
      console.log("History pop by modal close")
      window.history.back();
    }
    onModalClose()
  }

  useEffect(() => {
    if (MODAL_HOTSPOT_TYPES.includes(kind) && window.history && window.history.pushState) {
        setShouldBackOnModalClose(true)

        const originalPath = window.location.href
        const pathWithoutPreselectedHotspot = removePreselectedHotspotFromUrl(window.location.href, id, hotspotConfig?.identifier)

        if (window.isHotspotModalOpenImageMapId_UNIQUE_GLOBAL !== imageMap.id) {
          console.log("Pushing history")
          window.isHotspotModalOpenImageMapId_UNIQUE_GLOBAL = imageMap.id
          window.history.replaceState("", "", pathWithoutPreselectedHotspot);
          window.history.pushState('modalShow', "", originalPath);
        } else {
          console.log("Skipping push due to alrerady open modal")
        }
    }
  }, [])

  useEffect(() => {
    if (MODAL_HOTSPOT_TYPES.includes(kind) && window.history) {
      window.onpopstate = (event) => {
        if (window.isHotspotModalOpenImageMapId_UNIQUE_GLOBAL) {
          console.log("History pop")
          window.isHotspotModalOpenImageMapId_UNIQUE_GLOBAL = null
        }
      }
    }
  }, [])


  useEffect(() => {
    if (MODAL_HOTSPOT_TYPES.includes(kind)) {
      const listener = (event) => {
        onModalClose()
      }

      addEventListener('popstate', listener);
      return () => {
        removeEventListener('popstate', listener);
      }
    }
  }, [onModalClose, kind])

  const props = {
    hotspot,
    data,
    downloadFiles,
    imageMap,
    onModalClose: wrappedOnModalClose,
  }

  try {
    switch (kind) {
      // key is important so the component gets rerendered for different hotspots
      case "chat":
        return <ChatPreview key={id} {...props}/>;
      case "group_chat":
        return <GroupChatPreview key={id} {...props}/>;
      case "text":
        return <TextPreview key={id} {...props}/>;
      case "downloads":
        return <DownloadsPreview key={id} {...props}/>;
      case "iframe":
        return <RawHtmlPreview key={id} {...props}/>;
      case "support_chat":
        return <SupportChat key={id} {...props}/>;
      case "lead_generation":
        return <LeadGenerationPreview key={id} {...props} imageMap={imageMap}/>;
      case "pdf_viewer":
        return <PdfViewer key={id} {...props}/>
      case "contact":
        return <ContactsPreview key={id} {...props}/>
      case "appointment":
        return <MeetingPopup key={id} {...props}/>
      case "direct_messaging":
        return <DirectMessagingPopup key={id} {...props} hotspot={hotspot}/>
      case "iframe_url":
        return <IframePopup key={id} {...props}/>
      case "chat_roulette":
        return <ChatRoulettePopup key={id} {...props}/>
      case "image_map_id":
      case "redirect":
      case "hidden":
      case "slideshow":
      case "video":
      case "inline_html":
        return <></>;
      default:
        console.error("No valid kind for \"" + String(kind) + "\" found!!!!", props.hotspot, id, kind, imageMap)
        return null;
    }
  } catch (ex) {
    console.error(ex)
    if (typeof Sentry !== 'undefined') {
      Sentry.captureException(ex);
    }
    return <div className="alert alert-danger">An error occured: {ex.message}</div>
  }
}
